import React, {useEffect, useRef, useState} from "react";
import * as d3 from "d3";
import ForceGraph3D from '3d-force-graph';
import * as d3_3d from "d3-force-3d";
import * as THREE from 'three';
import * as BufferGeometryUtils from 'three/addons/utils/BufferGeometryUtils.js';
import {
    CircularProgress, Fab,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Skeleton,
    TextField,
    ThemeProvider
} from "@mui/material";
import Button from "@mui/material/Button";
import HubIcon from '@mui/icons-material/Hub';
import SideBar from "./SideBar";
import TopNavBar from "./TopNavBar";
import ToolBar from "./ToolBar";
import {DropDownItem} from "./DropDown";
import CreateNewFolderSharpIcon from "@mui/icons-material/CreateNewFolderSharp";
import DriveFolderUploadSharpIcon from "@mui/icons-material/DriveFolderUploadSharp";
import SaveSharpIcon from "@mui/icons-material/SaveSharp";
import SaveAsSharpIcon from "@mui/icons-material/SaveAsSharp";
import TabNavigator from "./TabNavigator";
import "./NetworkGraph.css";
import {readFileContent, hexToRGBA} from "./Globals.js";
import {CombinedViewDialog} from "./Dialog";
import {js} from "three/nodes";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import CenterFocusStrongIcon from "@mui/icons-material/CenterFocusStrong";


function ZoomControl(props) {
    return (
        <div className="fixed bottom-4 right-4 flex flex-col space-y-4">
            <Fab color="primary"
                 aria-label="add"
                 size="small"
                 onClick={() => {
                     d3.select('#networkGraphSvg').call(props.zoomRef.current.scaleBy, 1.2);
                 }}
            >
                <AddIcon/>
            </Fab>
            <Fab
                color="error"
                aria-label="remove"
                size="small"
                onClick={() => {
                    d3.select('#networkGraphSvg').call(props.zoomRef.current.scaleBy, 0.8);
                }}
            >
                <RemoveIcon/>
            </Fab>
            <Fab color="secondary"
                 aria-label="center"
                 size="small"
                 onClick={() => {
                     const svg = d3.select('#networkGraphSvg');
                     const clientSvg = svg.node();
                     svg.call(props.zoomRef.current.scaleTo, 1)
                     svg.call(props.zoomRef.current.translateTo, clientSvg.clientWidth * 0.5, clientSvg.clientHeight * 0.5);
                 }}
            >
                <CenterFocusStrongIcon/>
            </Fab>
        </div>
    );
}

function handleZoom(e) {
    d3.select('#zoomer').attr('transform', e.transform);
}

const NetworkGraph = (props) => {
    const [openProperties, setOpenProperties] = useState(false);
    const zoomRef = useRef(null);
    const toggleProperties = () => {
        setOpenProperties(!openProperties);
    }
    const [jsonData, setJsonData] = useState({
        "nodes": [
            {
                "id": "0"
            },
            {
                "id": "1"
            },
            {
                "id": "2"
            },
            {
                "id": "3",
                "fixedX": 0.356,
                "fixedY": 0.605
            }
        ],
        "links": [
            {
                "source": "0",
                "target": "1",
                "label": null,
                "directed": true
            },
            {
                "source": "0",
                "target": "2",
                "label": null
            },
            {
                "source": "0",
                "target": "3",
                "label": null,
                "directed": true
            },
        ]
    });
    const [standardNodeColor, setStandardNodeColor] = useState("#000000");
    const [standardEdgeColor, setStandardEdgeColor] = useState('#aaa');
    const [highlightNodeColor, setHighlightNodeColor] = useState("#ff0000");
    const [highlightEdgeColor, setHighlightEdgeColor] = useState("#ff0000");
    const [previousObject, setPreviousObject] = useState(null);
    const [selectedTab, setSelectedTab] = useState("social");
    const [selectedObject, setSelectedObject] = useState(null);
    const selectedObjectRef = useRef(null);
    const [openToolBar, setOpenToolBar] = useState(true);
    const [editMode, setEditMode] = useState(true);
    const [addingNode, setAddingNode] = useState(false);
    const [addingEdge, setAddingEdge] = useState(false);
    const [newNode, setNewNode] = useState(null);
    const [movingNode, setMovingNode] = useState(false);
    const [historyStack, setHistoryStack] = useState([]);
    const [futureStack, setFutureStack] = useState([]);
    const [showNodeLabels, setShowNodeLabels] = useState(true);
    const [showEdgeLabels, setShowEdgeLabels] = useState(true);
    const [nodeFontColor, setNodeFontColor] = useState("#ffac0b");
    const [edgeFontColor, setEdgeFontColor] = useState("#aa33ff");
    const [nodeRadius, setNodeRadius] = useState(30);
    const [edgeWidth, setEdgeWidth] = useState(10);
    const [edgeSettingsSocialSpatial, setEdgeSettingsSocialSpatial] = useState('#468e63')
    const [edgeSettingsSocialSocial, setEdgeSettingsSocialSocial] = useState('#aaa')
    const [edgeSettingsAdvanced, setEdgeSettingsAdvanced] = useState(true);
    const [nodeSettingsSocial, setNodeSettingsSocial] = useState('#000000')
    const [nodeSettingsSpatial, setNodeSettingsSpatial] = useState('#475f8e')
    const [nodeSettingsAdvanced, setNodeSettingsAdvanced] = useState(true);
    const [edgeLabels, setEdgeLabels] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [triggerDraw, setTriggerDraw] = useState(false);
    const xScaleRef = useRef(null);
    const yScaleRef = useRef(null);
    const sourceNode = useRef(null);
    const previewEdge = useRef(null);
    const graph_3d = useRef(null);
    const sideBarRef = useRef(null);
    const [drawGraph, setDrawGraph] = useState(true);
    const [currentCombiner, setCurrentCombiner] = useState("percentage");
    const [simulationData3d, setSimulationData3d] = useState({
        "nodes": [
            {
                "id": "0"
            },
            {
                "id": "1"
            },
            {
                "id": "2",
                "fixedX": 0.004,
                "fixedY": 0.358
            },
            {
                "id": "3",
                "label": "abd",
                "fixedX": 0.82,
                "fixedY": 0.023
            },
            {
                "id": "4"
            },
            {
                "id": "5"
            }
        ],
        "links": [
            {
                "source": "0",
                "target": "1",
                "label": null
            },
            {
                "source": "0",
                "target": "2",
                "label": null
            },
            {
                "source": "0",
                "target": "3",
                "label": null
            },
            {
                "source": "0",
                "target": "4",
                "label": null
            },
            {
                "source": "0",
                "target": "5",
                "label": null
            },
            {
                "source": "1",
                "target": "3",
                "label": null
            },
            {
                "source": "3",
                "target": "4",
                "label": null
            },
            {
                "source": "4",
                "target": "5",
                "label": null
            }
        ]
    });
    const [unsavedChanges, setUnsavedChanges] = useState(false);
    const drawCombined = useRef(true);
    const [combinedDialog, setCombinedDialog] = useState(false);
    const combinedWarningThreshold = 50;
    const toolBarToggle = () => {
        setOpenToolBar(!openToolBar);
    }
    let nodeMapping = {};
    let simulationJson = {};

    const handleUploadData = (nodeData, grData, spatialData) => {
        readInNodes(nodeData, grData, spatialData).then(() => {
        });
    }


    const addEdge = (sourceNode, targetNode) => {
        setUnsavedChanges(true);
        setFutureStack([])
        const oldJson = JSON.parse(JSON.stringify(jsonData));
        setHistoryStack(prevHistoryStack => [...prevHistoryStack, oldJson]);
        const newEdge = {
            source: String(sourceNode.current.id),
            target: String(targetNode.id),
        }
        const updatedJsonData = {...jsonData};
        updatedJsonData.links.push(newEdge);
        setJsonData(updatedJsonData);
        setNewNode(newEdge);

    }
    const addNode = (newNode) => {
        debugger
        setUnsavedChanges(true);
        setFutureStack([])
        setNewNode(newNode);
        const oldJson = JSON.parse(JSON.stringify(jsonData));
        setHistoryStack(prevHistoryStack => [...prevHistoryStack, oldJson]);
        const lastId = jsonData.nodes.length > 0 ? Math.max(...jsonData.nodes.map(node => node.id)) : -1;
        newNode.id = String(Number(lastId) + 1);

        const updatedJsonData = {...jsonData};


        updatedJsonData.nodes.push(newNode);

        setJsonData(updatedJsonData);
    }
    const undoFunc = () => {
        const lastAction = historyStack[historyStack.length - 1];
        const lastSelectedObject = lastAction.nodes.find(node => node.id === selectedObject?.id) ??
            lastAction.links.find(link => link.source === (selectedObject?.source?.id ?? selectedObject?.source) &&
                link.target === (selectedObject?.target?.id ?? selectedObject?.target));
        if (lastSelectedObject) {
            selectObject(lastSelectedObject);
        }
        setFutureStack(prevFutureStack => [...prevFutureStack, jsonData]);
        setJsonData(lastAction);
        setHistoryStack(historyStack.slice(0, historyStack.length - 1));

    }
    const redoFunc = () => {
        const lastAction = futureStack[futureStack.length - 1];
        const lastSelectedObject = lastAction.nodes.find(node => node.id === selectedObject?.id) ??
            lastAction.links.find(link => link.source === (selectedObject?.source?.id ?? selectedObject?.source) &&
                link.target === (selectedObject?.target?.id ?? selectedObject?.target));
        if (lastSelectedObject) {
            selectObject(lastSelectedObject);
        }
        setHistoryStack(prevHistoryStack => [...prevHistoryStack, jsonData]);
        setJsonData(lastAction);
        setFutureStack(futureStack.slice(0, futureStack.length - 1));

    }

    function saveUserConfig(json) {
        debugger
        let userConfig = {
            standardNodeColor: standardNodeColor,
            standardEdgeColor: standardEdgeColor,
            highlightNodeColor: highlightNodeColor,
            highlightEdgeColor: highlightEdgeColor,
            nodeFontColor: nodeFontColor,
            edgeFontColor: edgeFontColor,
            nodeRadius: nodeRadius,
            edgeWidth: edgeWidth,
            edgeSettingsAdvanced: edgeSettingsAdvanced,
            edgeSettingsSocialSpatial: edgeSettingsSocialSpatial,
            edgeSettingsSocialSocial: edgeSettingsSocialSocial,
            nodeSettingsAdvanced: nodeSettingsAdvanced,
            nodeSettingsSocial: nodeSettingsSocial,
            nodeSettingsSpatial: nodeSettingsSpatial,
            edgeLabels: edgeLabels,
            primaryColor: props.primaryColor,
            secondaryColor: props.secondaryColor,
        }
        json = {...json, ...userConfig, ...sideBarRef.current.getUserConfig()};
        return json;
    }

    function setUserConfig(json) {
        setStandardNodeColor(json.standardNodeColor);
        setStandardEdgeColor(json.standardEdgeColor);
        setHighlightNodeColor(json.highlightNodeColor);
        setHighlightEdgeColor(json.highlightEdgeColor);
        setNodeFontColor(json.nodeFontColor);
        setEdgeFontColor(json.edgeFontColor);
        setNodeRadius(json.nodeRadius);
        setEdgeWidth(json.edgeWidth);
        setEdgeSettingsAdvanced(json.edgeSettingsAdvanced);
        setEdgeSettingsSocialSpatial(json.edgeSettingsSocialSpatial);
        setEdgeSettingsSocialSocial(json.edgeSettingsSocialSocial);
        setNodeSettingsAdvanced(json.nodeSettingsAdvanced);
        setNodeSettingsSocial(json.nodeSettingsSocial);
        setNodeSettingsSpatial(json.nodeSettingsSpatial);
        setEdgeLabels(json.edgeLabels);
        props.setPrimaryColor(json.primaryColor);
        props.setSecondaryColor(json.secondaryColor);
        sideBarRef.current.setUserConfig(json);
    }

    function download(filename, text, fileType = ".pr") {
        return new Promise((resolve, reject) => {
            if (window.showSaveFilePicker) {
                const opts = {
                    startIn: "documents",
                    suggestedName: "project",
                    types: [
                        {
                            description: "Project file",
                            accept: {"text/plain": [fileType]},
                        },
                        {
                            description: 'PNG image',
                            accept: {'image/png': ['.png']}
                        }
                    ],
                };
                window.showSaveFilePicker(opts)
                    .then(async fileHandle => {
                        debugger
                        if (fileType === ".png") {
                            const blobText = await text;
                            var arr = blobText.split(','), mime = arr[0].match(/:(.*?);/)[1],
                                bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
                            while (n--) {
                                u8arr[n] = bstr.charCodeAt(n);
                            }
                            text = new Blob([u8arr], {type: mime});
                        }
                        const writable = await fileHandle.createWritable();
                        await writable.write(text)
                        await writable.close();
                        resolve({"success": true});
                    }).catch(error => {
                    reject(error);
                });
            } else {
                if (fileType !== ".png") {
                    var blob = new Blob([text], {type: "text/plain;charset=utf-8"});
                    var url = URL.createObjectURL(blob);
                }
                var a = document.createElement('A');
                a.href = url;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                resolve({"success": true});
            }
        });
    }

    const handleExportProject = async () => {
        let grString = `${jsonData.nodes.length} ${jsonData.links.length}\n`;
        jsonData.links.forEach((link, index) => {
            grString += `${link.source} ${link.target} ${link.label ?? ''}\n`;
            if (!link.directed) {
                grString += `${link.target} ${link.source} \n`
            }
        });
        let spatialNodes = jsonData.nodes.filter(node => node.fixedX !== undefined);
        let coString = `${spatialNodes.length} ${spatialNodes[0].width ? '4' : '2'}\n`;
        spatialNodes.forEach((node, index) => {
            coString += `${node.id} ${node.fixedX} ${node.fixedY} ${node.width ? node.fixedX + node.width : ''} ${node.height ? node.fixedY + node.height : ''}`;
            if (index !== spatialNodes.length - 1) {
                coString += '\n';
            }
        });
        return [grString, coString];

    }
    useEffect(() => {
            const isRect = jsonData.nodes.some(node => node.width && node.height);
            if (movingNode) {
                const forceNodes = d3.select('#forceNodes');

                forceNodes.selectAll('g.node-group')
                    .call(d3.drag()
                        .on("drag", dragNode)
                        .on("end", dragNodeEnded));

            } else {
                d3.select('#forceNodes').selectAll(isRect ? 'rect' : 'circle')
                    .on('click', null);
            }
        }
        , [movingNode])

    function dragNode(event, d) {
        debugger
        const zoomerRef = d3.select('#networkGraphSvg').node();
        let [xref, yref] = d3.pointer(event, zoomerRef);
        console.log('ref', xref, yref)

        // Convert the mouse pointer position to the domain
        const fixedX = xScaleRef.current.invert(xref - 50);
        const fixedY = yScaleRef.current.invert(yref - 100);
        console.log(`fixedX: ${fixedX}, fixedY: ${fixedY}`);
        d.fixedX = fixedX;
        d.fixedY = fixedY;
        d3.select(this)
            .attr('transform', d => {
                debugger
                if (d.width !== undefined && d.height !== undefined) {
                    return `translate(${xScaleRef.current(d.fixedX - d.width / 2)},${yScaleRef.current(d.fixedY + d.height / 2)})`
                } else {
                    return `translate(${xScaleRef.current(d.fixedX)},${yScaleRef.current(d.fixedY)})`
                }
            })
    }


    function dragNodeEnded(event, d) {
        debugger
        setFutureStack([]);
        const oldJson = JSON.parse(JSON.stringify(jsonData));
        setHistoryStack(prevHistoryStack => [...prevHistoryStack, oldJson]);
        const newNode = {
            id: d.id,
            fixedX: +(d.width ? (Number(d.fixedX) - d.width / 2).toFixed(3) : Number(d.fixedX).toFixed(3)),
            fixedY: +(d.height ? (Number(d.fixedY) + d.height / 2).toFixed(3) : Number(d.fixedY).toFixed(3)),
            width: d.width,
            height: d.height
        }
        setUnsavedChanges(true);
        setNewNode(newNode);
        setJsonData(prevJsonData => ({
            ...prevJsonData,
            nodes: prevJsonData.nodes.map(node =>
                node.id === d.id
                    ? newNode
                    : node
            ),
        }));
        setMovingNode(false);
    }


    useEffect(() => {
        const svg = d3.select('#networkGraphSvg');
        const isRect = jsonData.nodes.some(node => node.width && node.height);
        const maxX = Math.max(...jsonData.nodes.map(n => Number(n.fixedX ?? 0) + (n.width ?? 0)));
        const maxY = Math.max(...jsonData.nodes.map(n => Number(n.fixedY ?? 0) + (n.height ?? 0)));
        if (addingNode) {
            svg.on('click', e => {
                if (addingNode) {

                    // Get the mouse pointer position
                    let [x, y] = d3.pointer(e);
                    // Convector the mouse pointer position to the domain
                    let fixedX = xScaleRef.current.invert(x - 50);
                    let fixedY = yScaleRef.current.invert(y - 100);
                    if (isRect) {
                        fixedX = (fixedX - (maxX * 0.1) / 2).toFixed(3);
                        fixedY = (fixedY + (maxY * 0.1) / 2).toFixed(3);
                    }
                    addNode({
                        fixedX: +Number(fixedX).toFixed(3),
                        fixedY: +Number(fixedY).toFixed(3),
                        width: isRect ? +(Number(maxX) * 0.1).toFixed(3) : undefined,
                        height: isRect ? +(Number(maxY) * 0.1).toFixed(3) : undefined
                    });
                    console.log(`fixedX: ${fixedX}, fixedY: ${fixedY}`);
                }
            })
        } else {
            svg.on('click', null);
        }
        if (addingEdge) {
            const forceNodes = d3.select('#forceNodes');
            forceNodes.selectAll('circle')
                .on('click', (event, node) => {
                        if (addingEdge) {
                            if (sourceNode.current === null) {
                                // If no source node is selected, set the clicked node as the source node
                                sourceNode.current = node;

                                previewEdge.current = forceNodes.append('line')
                                    .style('stroke', 'red')
                                    .style('stroke-width', 4)
                                    .style('stroke-dasharray', '5,5') // Make the line dashed
                                    .attr('x1', node.x)
                                    .attr('y1', node.y)
                                    .attr('x2', node.x)
                                    .attr('y2', node.y)
                                    .style('pointer-events', 'none');

                                // Update the preview edge on mouse move
                                svg.on('mousemove', (event) => {
                                    const zoomerRef = d3.select('#zoomer').node();
                                    let [xref, yref] = d3.pointer(event, zoomerRef);
                                    console.log('ref', xref, yref)

                                    // Convert the mouse pointer position to the domain
                                    const x = xref;
                                    const y = yref;

                                    previewEdge.current
                                        .attr('x1', sourceNode.current.x)
                                        .attr('y1', sourceNode.current.y)
                                        .attr('x2', x)
                                        .attr('y2', y);
                                });
                            } else {
                                // If a source node is already selected, create a new edge
                                addEdge(sourceNode, node);
                                svg.on('mousemove', null);
                                setAddingEdge(false);
                                // Reset the source node and remove the edge preview
                                sourceNode.current = null;
                                previewEdge.current.remove();
                                previewEdge.current = null;

                            }
                        }
                    }
                );
        } else {
            svg.on('mousemove', null);
            sourceNode.current = null;
            previewEdge.current?.remove();
        }

    }, [addingNode, addingEdge, jsonData]);

    useEffect(() => {
        if (selectedTab === "social" && addingNode) {
            setAddingNode(false);
            addNode({});
        }
    }, [addingNode]);

    function getNodeColor(node) {
        debugger
        if (node.id === selectedObject?.id) {
            return hexToRGBA(highlightNodeColor);
        }
        if (selectedTab === 'combined') {
            if (currentCombiner === 'percentage') {
                if (node.id?.includes('projected')) {
                    return hexToRGBA("#ffac0b");
                }
            }
        }
        if (nodeSettingsAdvanced) {
            return (typeof node.fixedX === 'number') ? hexToRGBA(nodeSettingsSpatial) : hexToRGBA(nodeSettingsSocial);
        } else {
            return hexToRGBA(standardNodeColor);
        }
    }

    function getLinkColor(link) {
        let specialEdgeDict = {};
        edgeLabels.forEach(edge => {
            specialEdgeDict[edge.label] = edge.color;
        })
        let spatialNodeIds = new Set();
        jsonData.nodes.forEach(node => {
            if (node.fixedX) {
                spatialNodeIds.add(node.id);
            }
        });
        if ((link.source?.id ?? link.source) === (selectedObject?.source?.id ?? selectedObject?.source) && (link.target?.id ?? link.target) === (selectedObject?.target?.id ?? selectedObject?.target)) {
            return highlightEdgeColor;
        } else {
            if (selectedTab === "combined") {
                if (currentCombiner === 'percentage') {
                    if (link.target.includes || link.source.includes || link.target?.id.includes('projected') || link.source?.id.includes('projected')) {
                        return hexToRGBA("#e010cb");
                    }
                }
            }
            if (link.label in specialEdgeDict) {
                return specialEdgeDict[link.label];
            }
            if (edgeSettingsAdvanced) {
                debugger
                if (currentCombiner === 'percentage') {
                    return edgeSettingsSocialSocial;
                } else {
                    return (spatialNodeIds.has(link.target?.id ?? link.target) || spatialNodeIds.has(link.source?.id ?? link.source)) ? edgeSettingsSocialSpatial : edgeSettingsSocialSocial;
                }
            } else {
                return standardEdgeColor;
            }
        }
    }

    function getLinkMarker(link) {
        let spatialNodeIds = new Set();
        jsonData.nodes.forEach(node => {
            if (typeof node.fixedX === 'number') {
                spatialNodeIds.add(node.id);
            }
        });
        let specialEdgeDict = {};
        edgeLabels.forEach(edge => {
            specialEdgeDict[edge.label] = edge.color;
        })

        if (link.directed) {
            if ((link.source?.id ?? link.source) === (selectedObject?.source?.id ?? selectedObject?.source) && (link.target?.id ?? link.target) === (selectedObject?.target?.id ?? selectedObject?.target)) {
                return 'url(#arrowSelected)';
            } else {
                if (link.label in specialEdgeDict) {
                    return 'url(#arrowSpecial' + link.label + ')';
                }
                if (edgeSettingsAdvanced) {
                    return (spatialNodeIds.has(link.target?.id ?? link.target) || spatialNodeIds.has(link.source?.id ?? link.source)) ? 'url(#arrowSocialSpatial)' : 'url(#arrowSocialSocial)';
                } else {
                    return 'url(#arrowhead)';
                }
            }
        } else return "";
    }

    useEffect(() => {
        let specialEdgeDict = {};
        edgeLabels.forEach(edge => {
            specialEdgeDict[edge.label] = edge.color;
        })
        if (selectedTab === "combined") {
            if (drawCombined) {
                if (!graph_3d.current) {
                    return;
                }
                graph_3d.current
                    .nodeThreeObject((node) => {

                        if (node.fixedX && (currentCombiner !== 'percentage') || node.id.includes('projected')) {
                            const cylinderGeometry = new THREE.CylinderGeometry(0.3, 0.3, 6, 16);
                            const sphereGeometry = new THREE.SphereGeometry(1.7, 32, 32);
                            cylinderGeometry.translate(0, 3, 0);
                            sphereGeometry.translate(0, 7, 0);
                            const merge = BufferGeometryUtils.mergeGeometries([cylinderGeometry, sphereGeometry])
                            const combinedMesh = new THREE.Mesh(
                                merge,
                                new THREE.MeshLambertMaterial({
                                    color: getNodeColor(node),
                                    opacity: 1
                                })
                            );
                            combinedMesh.rotation.set(0, Math.PI / 2, Math.PI / 2);
                            return combinedMesh;
                        } else {
                            return new THREE.Mesh(
                                new THREE.SphereGeometry(2),
                                new THREE.MeshLambertMaterial({
                                    color: getNodeColor(node),
                                    opacity: 1
                                })
                            )
                        }
                    })
                    .linkColor(link => getLinkColor(link))
                    .linkMaterial(link => {
                        let isProjectedLink = false;
                        if (currentCombiner === 'percentage') {
                            if (link.source?.id?.includes('projected') || link.target?.id?.includes('projected')) {
                                isProjectedLink = true;
                            }
                            if (link.source.includes) {
                                isProjectedLink = link.source.includes('projected') || link.target.includes('projected');
                            }
                        }
                        if (isProjectedLink) {
                            var material = new THREE.LineDashedMaterial({
                                color: getLinkColor(link),
                                linewidth: 1000,
                                scale: 20,
                                dashSize: 10,
                                gapSize: 20,
                            });
                            return material;
                        } else {
                            return false;
                        }
                    })
            }

        }

        if (previousObject) {
            d3.select(`#node-${previousObject?.id}`)
                .style('stroke', d => {
                    if (d.width && selectedTab === 'spatial') {
                        return '#aaa';
                    }
                    if (nodeSettingsAdvanced) {
                        return (typeof previousObject.fixedX === 'number') ? nodeSettingsSpatial : nodeSettingsSocial;
                    } else {
                        return standardNodeColor;
                    }
                });
            d3.select(`#edge-${previousObject?.source?.id ?? previousObject?.source}-${previousObject?.target?.id ?? previousObject?.target}`)
                .style('stroke', d => {
                    if (d.label in specialEdgeDict) {
                        return specialEdgeDict[d.label];
                    }
                    if (edgeSettingsAdvanced) {
                        if (currentCombiner === 'percentage') {
                            return edgeSettingsSocialSocial
                        } else {
                            return (d.source?.fixedX || d.target?.fixedX) ? edgeSettingsSocialSpatial : edgeSettingsSocialSocial;
                        }
                    } else {
                        return standardEdgeColor;
                    }

                })
                .attr('marker-end', d => getLinkMarker(d));
        }
        setPreviousObject(selectedObject);
        d3.select(`#node-${selectedObject?.id}`)
            .style('stroke', highlightNodeColor);
        d3.select(`#edge-${selectedObject?.source?.id ?? selectedObject?.source}-${selectedObject?.target?.id ?? selectedObject?.target}`)
            .style('stroke', highlightEdgeColor)
            .attr('marker-end', d => d.directed ? 'url(#arrowSelected)' : '');
        selectedObjectRef.current = selectedObject;
    }, [selectedObject]);
    useEffect(() => {

        if (selectedTab === "combined") {
            if (jsonData.nodes.length > combinedWarningThreshold) {
                setCombinedDialog(true);
                drawCombined.current = false;
            }
        }
    }, [selectedTab, jsonData]);
    useEffect(() => {
        simulationJson = JSON.parse(JSON.stringify(jsonData));
        debugger
        if (drawGraph && ((selectedTab === "combined" && drawCombined.current) || (selectedTab !== "combined"))) {
            drawNetwork().then(r => {
                if (selectedObject) {
                    const findSelectedObject = jsonData.nodes.find(node => node.id === selectedObject.id) ??
                        jsonData.links.find(link => link.source === (selectedObject.source?.id ?? selectedObject.source) &&
                            link.target === (selectedObject.target?.id ?? selectedObject.target));
                    if (findSelectedObject) {
                        selectObject(findSelectedObject);
                    }
                }
                if (newNode) {
                    selectObject(newNode)
                    setNewNode(null);
                }
            });
        } else {
            d3.select("#forceNodes").selectAll("*").remove();
            d3.select('#labels').selectAll("*").remove();
        }

    }, [jsonData, drawGraph, triggerDraw, selectedTab, showEdgeLabels, showNodeLabels, standardNodeColor, standardEdgeColor, edgeFontColor, nodeFontColor,
        nodeRadius, edgeWidth, edgeSettingsAdvanced, edgeSettingsSocialSocial, edgeSettingsSocialSpatial, nodeSettingsAdvanced, nodeSettingsSocial, nodeSettingsSpatial, edgeLabels]);

    const drawNetwork = async () => {
        debugger
        if (jsonData.nodes.length === 0) {
            d3.select("#forceNodes").selectAll("*").remove();
            d3.select('#labels').selectAll("*").remove();
            return;
        }
        if (selectedTab === 'combined' && !drawCombined.current) {
            return;
        }
        const parentDiv = document.getElementById('networkGraphSvg');
        const width = parentDiv.clientWidth - 100
        const height = parentDiv.clientHeight - 200;
        const zoomer = d3.select('#zoomer')
        zoomer.attr("transform", d3.zoomIdentity)
        d3.select("#networkGraphSvg").call(d3.zoom().transform, d3.zoomIdentity);
        // Clear the SVG canvas
        d3.select("#forceNodes").selectAll("*").remove();
        d3.select('#labels').selectAll("*").remove();

        const svg = d3.select("#networkGraphSvg")


        d3.select('#zoomer')
            .attr('width', width + 'px')
            .attr('height', height + 'px')

        if (selectedTab === "spatial") {
            d3.select('#zoomer').attr('transform', 'translate(50, 100)');
            svg.call(d3.zoom().on("zoom", (event) => {

            }))
            simulationJson.nodes = simulationJson.nodes.filter(node => node.fixedX !== undefined && node.fixedY !== undefined);
            const padding = Math.max(...simulationJson.nodes.map(n => Number(n.fixedX) + (Number(n.width ?? 0)))) * 0.02;
            xScaleRef.current = d3.scaleLinear()
                .domain([Math.min(...simulationJson.nodes.map(n => n.fixedX)) - padding, Math.max(...simulationJson.nodes.map(n => Number(n.fixedX) + (Number(n.width ?? 0)))) + padding])
                .range([0, width]);
            console.log(Math.min(...simulationJson.nodes.map(n => n.fixedY)), Math.max(...simulationJson.nodes.map(n => n.fixedY)))
            yScaleRef.current = d3.scaleLinear()
                .domain([Math.min(...simulationJson.nodes.map(n => Number(n.fixedY) - (Number(n.height ?? 0)))) - padding, Math.max(...simulationJson.nodes.map(n => Number(n.fixedY))) + padding])
                .range([height, 0]);
            const xAxis = d3.axisBottom(xScaleRef.current)
                .tickSize(-height);
            const yAxis = d3.axisLeft(yScaleRef.current)
                .tickSize(-width);

            // Add the x-axis to the SVG
            svg.select("#forceNodes").append("g")
                .attr('class', 'grid')
                .attr("transform", `translate(0,${height})`)
                .call(xAxis)
                .style("stroke-dasharray", "5 5");

            // Add the y-axis to the SVG
            svg.select("#forceNodes").append("g")
                .attr('class', 'grid')
                .call(yAxis)
                .style("stroke-dasharray", "5 5");
            const isRect = simulationJson.nodes.some(node => node.width && node.height);
            const nodesGroup = svg.select('#forceNodes')
                .selectAll("g.node-group")
                .data(simulationJson.nodes)
                .join("g")
                .attr("class", "node-group")
                .attr("transform", d => {
                    return `translate(${xScaleRef.current(d.fixedX)},${yScaleRef.current(d.fixedY)})`
                })
                .on('dblclick', (event, node) => {
                    selectObjectWithCheck(node);
                });


            nodesGroup.each(function (d) {
                d3.select(this).selectAll(isRect ? "rect" : "circle")
                    .data([d])
                    .join(isRect ? "rect" : "circle")
                    .attr("r", nodeRadius * 0.9)
                    .attr("width", d => {
                        return xScaleRef.current(Number(d.fixedX) + Number(d.width)) - xScaleRef.current(d.fixedX)
                    })
                    .attr("height", d => yScaleRef.current(d.fixedY) - yScaleRef.current(Number(d.fixedY) + Number(d.height)))
                    .attr("id", d => `node-${d.id}`)
                    .attr("fill", d => {
                        if (nodeSettingsAdvanced) {
                            return (typeof d.fixedX === 'number') ? nodeSettingsSpatial : nodeSettingsSocial;
                        } else {
                            return standardNodeColor;
                        }
                    })
                    .attr("stroke", d => {
                            if (d.id === selectedObject?.id) {
                                return highlightNodeColor;
                            } else {
                                if (isRect && selectedTab === 'spatial') {
                                    return '#aaa';
                                }
                                if (nodeSettingsAdvanced) {
                                    return (typeof d.fixedX === 'number') ? nodeSettingsSpatial : nodeSettingsSocial;
                                } else {
                                    return standardNodeColor;
                                }
                            }
                        }
                    )
                    .style("stroke-width", 2);
            });
            const maxFontSize = 30;
            const minFontSize = 10;
            const maxLength = 10;
            nodesGroup.append("text")
                .text(d => d.label ?? d.id)
                .attr("dx", 0)
                .attr('id', d => `text-${d.id}`)
                .attr("dy", "0.35em")
                .attr("x", d => {
                    if (!d.width) {
                        return 0
                    } else {
                        return (xScaleRef.current(Number(d.fixedX) + Number(d.width)) - xScaleRef.current(d.fixedX)) / 2
                    }
                })
                .attr("y", d => {
                    if (!d.height) {
                        return 0
                    } else {
                        return (yScaleRef.current(d.fixedY) - yScaleRef.current(Number(d.fixedY) + Number(d.height))) / 2
                    }
                })
                .style("text-anchor", "middle")
                .style('fill', nodeFontColor)
                .style('z-index', 100)
                .style('pointer-events', 'none')
                .style('font-size', d => {
                    if (!d.label) {
                        return maxFontSize + 'px';
                    } else {
                        const length = d.label.length;
                        const fontSize = maxFontSize - ((length / maxLength) * (maxFontSize - minFontSize));
                        return `${Math.max(fontSize, minFontSize)}px`; // ensure font size is not less than the minimum
                    }
                });

            console.log('SIMUT', simulationJson);
            console.log('JSONDATA', jsonData);

        } else if (selectedTab === "social") {
            zoomRef.current = d3.zoom()
                .on("zoom", handleZoom)
            console.log(zoomRef.current)
            svg.call(zoomRef.current)
                .on('dblclick.zoom', null);

            d3.select('#arrowhead')
                .attr('fill', standardEdgeColor)
                .attr('refX', 0.27 * nodeRadius + 13 - 0.35 * edgeWidth);
            d3.select('#arrowSelected')
                .attr('fill', highlightEdgeColor)
                .attr('refX', 0.27 * nodeRadius + 13 - 0.35 * edgeWidth);
            d3.select('#arrowSocialSocial')
                .attr('fill', edgeSettingsSocialSocial)
                .attr('refX', 0.27 * nodeRadius + 13 - 0.35 * edgeWidth);
            edgeLabels.forEach(edge => {
                d3.select(`#arrowSpecial${edge.label}`)
                    .attr('fill', edge.color)
                    .attr('refX', 0.27 * nodeRadius + 13 - 0.35 * edgeWidth);
            });
            d3.select('#arrowSocialSpatial')
                .attr('fill', _ => {
                    if (currentCombiner === 'percentage') {
                        return edgeSettingsSocialSocial
                    } else {
                        return edgeSettingsSocialSpatial;
                    }
                })
                .attr('refX', 0.27 * nodeRadius + 13 - 0.35 * edgeWidth);

            let spatialNodeIds = new Set();
            simulationJson.nodes.forEach(node => {
                if (typeof node.fixedX === 'number') {
                    spatialNodeIds.add(node.id);
                }
            });
            let specialEdgeDict = {};
            edgeLabels.forEach(edge => {
                specialEdgeDict[edge.label] = edge.color;
            })
            debugger
            const links = svg.select('#forceNodes')
                .selectAll('path.link')
                .data(simulationJson.links)
                .enter()
                .append('path')
                .attr('class', 'link')
                .style('stroke', d => {
                    if (d.source === (selectedObject?.source?.id ?? selectedObject?.source) && d.target === (selectedObject?.target?.id ?? selectedObject?.target)) {
                        return highlightEdgeColor;
                    } else {
                        if (d.label in specialEdgeDict) {
                            return specialEdgeDict[d.label];
                        }
                        if (edgeSettingsAdvanced) {
                            debugger
                            if (currentCombiner === 'percentage') {
                                return edgeSettingsSocialSocial
                            } else {
                                return (spatialNodeIds.has(d.target) || spatialNodeIds.has(d.source)) ? edgeSettingsSocialSpatial : edgeSettingsSocialSocial;
                            }
                        } else {
                            return standardEdgeColor;
                        }
                    }
                })
                .style('stroke-width', edgeWidth)
                .attr('id', d => `edge-${d.source}-${d.target}`)
                .attr('marker-end', d => getLinkMarker(d))


            links.on('dblclick', (event, edge) => {
                selectObjectWithCheck(edge);
            });
            const node = svg.select('#forceNodes')
                .selectAll("circle")
                .data(simulationJson.nodes)
                .join("circle")
                .attr("r", nodeRadius)
                .attr("stroke", d => {
                    if (d.id === selectedObject?.id) {
                        return highlightNodeColor;
                    } else {
                        if (nodeSettingsAdvanced) {
                            return (typeof d.fixedX === 'number') ? nodeSettingsSpatial : nodeSettingsSocial;
                        } else {
                            return standardNodeColor;
                        }
                    }
                })
                .style("stroke-width", 7)
                .attr("id", d => `node-${d.id}`)
                .on('dblclick', (event, node) => {
                    selectObjectWithCheck(node);
                })
                .attr('fill', d => {
                    if (nodeSettingsAdvanced) {
                        return (typeof d.fixedX === 'number') ? nodeSettingsSpatial : nodeSettingsSocial;
                    } else {
                        return standardNodeColor;
                    }
                });

            const maxFontSize = 30;
            const minFontSize = 10;
            const maxLength = 10;
            let nodeText = null;
            if (showNodeLabels) {
                nodeText = svg.select('#forceNodes')
                    .selectAll("text")
                    .data(simulationJson.nodes)
                    .join("text")
                    .text(d => d.label ?? d.id)
                    .attr("dx", 0)
                    .attr("dy", "0.35em")
                    .style("text-anchor", "middle")
                    .style('fill', nodeFontColor)
                    .style('z-index', 100)
                    .style('pointer-events', 'none')
                    .style('font-size', d => {
                        if (!d.label) {
                            return maxFontSize + 'px';
                        } else {
                            const length = d.label.length;
                            const fontSize = maxFontSize - ((length / maxLength) * (maxFontSize - minFontSize));
                            return `${Math.max(fontSize, minFontSize)}px`;
                        }
                    });
            }
            let linkText = null;
            if (showEdgeLabels) {
                linkText = svg.select('#labels')
                    .selectAll("text")
                    .data(simulationJson.links)
                    .join("text")
                    .text(d => d.label ?? '')
                    .attr("dx", 12)
                    .attr("dy", ".35em")
                    .style('fill', edgeFontColor)
            }
            const simulation = d3.forceSimulation(simulationJson.nodes)
                .velocityDecay(0.8)
                .force("center", d3.forceCenter().x(width / 2).y(height / 2)) // Attraction to the center of the svg area
                .force("charge", d3.forceManyBody().strength(0.2))
                .force("collide", d3.forceCollide().strength(0.5).radius(70).iterations(1)) // Force that avoids circle overlapping
                .force("link", d3.forceLink()
                    .id((d) => {
                        return d.id
                    })
                    .links(simulationJson.links))

            simulation
                .nodes(simulationJson.nodes)
                .on("tick", function (tick) {
                        for (let i = 0; i < 5; i++) {
                            simulation.tick();
                        }
                        links
                            .attr("d", function (d) {
                                return `M${d.source.x},${d.source.y} L${d.target.x},${d.target.y}`;
                            });
                        node
                            .attr('cx', d => d.x)
                            .attr('cy', d => d.y)
                        links
                            .attr("x1", function (d) {
                                return d.source.x;
                            })
                            .attr("y1", function (d) {
                                return d.source.y;
                            })
                            .attr("x2", function (d) {
                                return d.target.x;
                            })
                            .attr("y2", function (d) {
                                return d.target.y;
                            });
                        if (showNodeLabels) {
                            nodeText
                                .attr("x", function (d) {
                                    return d.x;
                                })
                                .attr("y", function (d) {
                                    return d.y;
                                });
                        }
                        if (showEdgeLabels) {
                            linkText
                                .attr("x", function (d) {
                                    return (d.source.x + d.target.x) / 2;
                                })
                                .attr("y", function (d) {
                                    return (d.source.y + d.target.y) / 2;

                                });
                        }
                        if (simulation.alpha() < 0.000001) {
                            simulation.stop();
                        }
                    }
                );

            node.call(d3.drag()
                .on("start", dragstarted)
                .on("drag", dragged)
                .on("end", dragended))
            console.log('SIMUT', simulationJson);
            console.log('JSONDATA', jsonData);


            function dragstarted(event, d) {
                if (!event.active) simulation.alphaTarget(0.03).restart();
                console.log(' STARTED ', d)
                d.fx = d.x;
                d.fy = d.y;
            }

            function dragged(event, d) {
                console.log('DRAGGED', d)
                d.fx = event.x;
                d.fy = event.y;
            }

            function dragended(event, d) {
                if (!event.active) simulation.alphaTarget(0).restart();
                d.fx = null;
                d.fy = null;
            }
        } else {
            let projectedNodes = [];
            if (currentCombiner !== 'percentage') {
                simulationJson.nodes.forEach(node => {
                    if (node.fixedX) {
                        node.fx = node.fixedX;
                        node.fy = node.fixedY;
                    }
                });
            } else {
                simulationJson.nodes.forEach(node => {
                    if (typeof node.fixedX === 'number') {
                        projectedNodes.push(node);
                    }
                });
            }
            const planeWidth = 100;
            const planeHeight = 100;
            const simulation = d3.forceSimulation(simulationJson.nodes)
                .velocityDecay(0.8)
                .force("center", d3.forceCenter().x(5).y(5)) // Attraction to the center of the svg area
                .force("charge", d3.forceManyBody().strength(1))
                .force("collide", d3.forceCollide().strength(0.5).radius(15).iterations(1))
                .force("link", d3.forceLink()
                    .id((d) => {
                        return d.id
                    })
                    .links(simulationJson.links))
            simulation.on('tick', () => {

                if (simulation.alpha() < 0.01) {
                    simulation.stop();
                    const spatialNodes = simulationJson.nodes.filter(node => typeof node.fixedX === 'number');
                    const xValues = spatialNodes.map(node => node.fixedX);
                    const yValues = spatialNodes.map(node => node.fixedY);

                    const xMin = Math.min(...xValues);
                    const xMax = Math.max(...xValues);
                    const yMin = Math.min(...yValues);
                    const yMax = Math.max(...yValues);


                    const paddingPercent = 0.05; // 10% padding
                    const xPadding = planeWidth * paddingPercent;
                    const yPadding = planeHeight * paddingPercent;

                    const effectivePlaneWidth = planeWidth - (xPadding * 2);
                    const effectivePlaneHeight = planeHeight - (yPadding * 2);
                    const xScale = (xMin === xMax ? 1 : effectivePlaneWidth / (xMax - xMin)) * (1 - 2 * paddingPercent);
                    const yScale = (yMin === yMax ? 1 : effectivePlaneHeight / (yMax - yMin)) * (1 - 2 * paddingPercent);
                    const xOffset = (planeWidth - effectivePlaneWidth) / 2 + (planeWidth * paddingPercent);
                    const yOffset = (planeHeight - effectivePlaneHeight) / 2 + (planeHeight * paddingPercent);
                    debugger
                    simulationJson.nodes.forEach(node => {
                        if (currentCombiner === 'percentage') {
                            if (!node.id.includes('projected')) {
                                node.fx = node.x;
                                node.fy = node.y;
                                node.fz = 40;
                            }
                        } else {

                            if (node.fixedX) {
                                node.fx = ((node.fixedX - xMin) * xScale) + xOffset - (planeWidth / 2);
                                node.fy = ((node.fixedY - yMin) * yScale) + yOffset - (planeHeight / 2);
                                node.fz = 0;
                            } else {
                                node.fx = node.x;
                                node.fy = node.y;
                                node.fz = 40;
                            }
                        }
                    });

                    projectedNodes.forEach(node => {
                        debugger
                        simulationJson.nodes.push(
                            {
                                id: `${node.id}-projected`,
                                fx: ((node.fixedX - xMin) * xScale) + xOffset - (planeWidth / 2),
                                fy: ((node.fixedY - yMin) * yScale) + yOffset - (planeHeight / 2),
                                fz: 0,
                            }
                        )
                        simulationJson.links.push(
                            {
                                source: node.id,
                                target: `${node.id}-projected`,
                            }
                        )
                    });

                    const planeGeometry = new THREE.PlaneGeometry(planeHeight, planeWidth, 1, 1);
                    const planeSocialMaterial = new THREE.MeshLambertMaterial({
                        color: 0xADD8E6,
                        side: THREE.DoubleSide,
                        transparent: true,
                        opacity: 0.4,
                    });

                    const planeMaterial = new THREE.MeshLambertMaterial({
                        color: 0xADD8E6,
                        side: THREE.DoubleSide,
                        transparent: true,
                        opacity: 0.7,
                    });
                    const mesh = new THREE.Mesh(planeGeometry, planeMaterial);
                    const meshSocial = new THREE.Mesh(planeGeometry, planeSocialMaterial);
                    meshSocial.position.set(0, 0, 40)
                    mesh.position.set(0, 0, 0);
                    mesh.rotation.set(0, 0, 0);

                    graph_3d.current = ForceGraph3D({
                        controlType: 'trackball',
                        rendererConfig: {
                            antialias: true,
                            alpha: true,
                            preserveDrawingBuffer: true
                        },
                    })(document.getElementById('3dgraph'))
                        .graphData(simulationJson)
                        .width(width)
                        .height(height)
                        .nodeOpacity(1)
                        .linkOpacity(0.7)
                        .nodeRelSize(3)
                        .backgroundColor('rgba(200,200,200,0)')
                        .onNodeClick(node => {
                            selectObjectWithCheck(node);
                            console.log(`Clicked node ${node.id}`);
                            console.log('x ', node.x, 'y ', node.y, 'z ', node.z);
                        })
                        .nodeThreeObject((node) => {

                            if (node.fixedX && (currentCombiner !== 'percentage') || node.id.includes('projected')) {
                                const cylinderGeometry = new THREE.CylinderGeometry(0.3, 0.3, 6, 16);
                                const sphereGeometry = new THREE.SphereGeometry(1.7, 32, 32);
                                cylinderGeometry.translate(0, 3, 0);
                                sphereGeometry.translate(0, 7, 0);
                                const merge = BufferGeometryUtils.mergeGeometries([cylinderGeometry, sphereGeometry])
                                const combinedMesh = new THREE.Mesh(
                                    merge,
                                    new THREE.MeshLambertMaterial({
                                        color: getNodeColor(node),
                                        opacity: 1
                                    })
                                );
                                combinedMesh.rotation.set(0, Math.PI / 2, Math.PI / 2);
                                return combinedMesh;
                            } else {
                                return new THREE.Mesh(
                                    new THREE.SphereGeometry(2),
                                    new THREE.MeshLambertMaterial({
                                        color: getNodeColor(node),
                                        opacity: 1
                                    })
                                )
                            }
                        })
                        .linkDirectionalArrowLength(link => {
                            if (link.directed) {
                                return 4;
                            } else {
                                return 0;
                            }
                        })
                        .linkDirectionalArrowRelPos(d => {
                            if (d.target.fz === 0) {
                                return 1.05
                            } else {
                                return 1
                            }
                        })
                        .linkCurvature(0.15)
                        .onLinkClick(link => {
                                selectObjectWithCheck(link);
                                const acc = graph_3d;
                            }
                        )
                        .nodeLabel(node => {
                            return node.label ?? node.id
                        })
                        .linkMaterial(link => {
                            let isProjectedLink = false;
                            if (currentCombiner === 'percentage') {
                                if (link.source?.id?.includes('projected') || link.target?.id?.includes('projected')) {
                                    isProjectedLink = true;
                                }
                                if (link.source.includes) {
                                    isProjectedLink = link.source.includes('projected') || link.target.includes('projected');
                                }
                            }
                            if (isProjectedLink) {
                                var material = new THREE.LineDashedMaterial({
                                    color: getLinkColor(link),
                                    linewidth: 1000,
                                    scale: 20,
                                    dashSize: 10,
                                    gapSize: 20,
                                });
                                return material;
                            } else {
                                return false;
                            }
                        })
                        .linkPositionUpdate(lineObj => {
                            if (lineObj.geometry.type === "CylinderGeometry") return
                            lineObj.computeLineDistances()
                        })
                        .linkColor(link => getLinkColor(link))
                        .nodeColor(node => getNodeColor(node))
                        .cameraPosition({x: 0, y: -95, z: 70}, {x: 0, y: 30, z: 0}, 0.5)
                        .zoomToFit();

                    graph_3d.current.scene().add(mesh);

                }
            })

        }
        console.log("We also get here")
    }
    const readInNodes = async (nodeData, gr, spatialData) => {
        let tempJson = {
            "nodes": [],
            "links": []
        }
        const specialNodes = {};

        try {
            if (nodeData) {
                const nodeContent = await readFileContent(nodeData);
                const nodeSanitized = nodeContent.replace(/\r/g, '');
                const lines = nodeSanitized.split('\n');
                lines.forEach((line) => {
                    const [id, label] = line.split(' ');
                    specialNodes[id] = {"label": label}
                })
            }
            const grFileContent = await readFileContent(gr);
            const grSanitized = grFileContent.replace(/\r/g, '')
            const lines = grSanitized.split('\n');
            const [num_nodes, num_edges] = lines[0].split(' ');
            for (let i = 1; i < lines.length; i++) {
                const line = lines[i];
                if (line === '') continue;
                console.log('Line:', line);
                const coords = line.split(' ');
                if (!(coords[0] in nodeMapping)) {
                    nodeMapping[coords[0]] = true;
                    const customFirstNode = specialNodes[coords[0]]?.label;
                    tempJson.nodes.push(
                        {
                            "id": coords[0],
                            "label": customFirstNode,
                        }
                    )
                }
                if (!(coords[1] in nodeMapping)) {
                    const customSecondNode = specialNodes[coords[1]]?.label;
                    nodeMapping[coords[1]] = true;
                    tempJson.nodes.push(
                        {
                            "id": coords[1],
                            "label": customSecondNode,
                        }
                    )
                }
                const linkLabel = coords[2] ?? null;
                tempJson.links.push(
                    {
                        "source": coords[0],
                        "target": coords[1],
                        "label": linkLabel,
                    }
                )
            }
            if (spatialData) {
                const spatialContent = await readFileContent(spatialData);
                const nodeSanitized = spatialContent.replace(/\r/g, '');
                const lines = nodeSanitized.split('\n');
                for (let i = 1; i < lines.length; i++) {
                    const line = lines[i];
                    if (line === '') continue;
                    const [id, x, y, x2, y2] = line.split(' ');
                    const node = tempJson.nodes.find(node => node.id === id);
                    if (node) {
                        node.fixedX = +Number(x).toFixed(3);
                        node.fixedY = +Number(y).toFixed(3);
                    }
                    if (x2 && y2) {
                        node.width = +Number(x2 - x).toFixed(3);
                        node.height = +Number(y2 - y).toFixed(3);
                    }
                }
            }
            const linksCleaned = [];
            for (const link of tempJson.links) {
                const siblingLink = tempJson.links.find(l => l.source === link.target && l.target === link.source);
                if (!siblingLink) {
                    link.directed = true;
                } else {
                    const siblingIndex = tempJson.links.indexOf(siblingLink);
                    if (siblingIndex !== -1) {
                        tempJson.links.splice(siblingIndex, 1);
                    }
                }
            }

            setJsonData(tempJson);
            return tempJson;
        } catch (error) {
            console.error('Error:', error.message);
        }
    }
    const selectObject = (object) => {
        debugger
        setSelectedObject(object);
        setOpenProperties(true);
    }
    const selectObjectWithCheck = (object) => {
        debugger
        if (selectedObjectRef.current === object) {
            setSelectedObject(null);
            setOpenProperties(false);
            return;
        }
        setSelectedObject(object);
        setOpenProperties(true);
    }
    return (
        <ThemeProvider theme={props.theme}>
            <CombinedViewDialog
                openCondition={combinedDialog}
                setOpenCondition={setCombinedDialog}
                selectedTab={selectedTab}
                setSelectedTab={setSelectedTab}
                drawCombined={drawCombined}
                triggerDraw={triggerDraw}
                setTriggerDraw={setTriggerDraw}
            >
                You are trying to open the combined view with a large dataset. This may take a while. Do you want to
                continue?
            </CombinedViewDialog>
            <div className="h-screen">
                <TopNavBar theme={props.theme} propertiesToggle={toggleProperties}
                           download={download} handleExport={handleExportProject}
                           saveUserConfig={saveUserConfig}
                           setUserConfig={setUserConfig}
                           showProperties={openProperties}
                           unsavedChanges={unsavedChanges} setUnsavedChanges={setUnsavedChanges}
                           primaryColor={props.primaryColor} secondaryColor={props.secondaryColor}
                           showToolBar={openToolBar} setShowToolBar={setOpenToolBar}
                           toolBarToggle={toolBarToggle} jsonData={jsonData} setJsonData={setJsonData}
                           setSelectedObject={setSelectedObject} editMode={editMode}
                           setEditMode={setEditMode} undoFunc={undoFunc} redoFunc={redoFunc}
                           historyStack={historyStack} futureStack={futureStack}
                           selectedObject={selectedObject} highlightNodeColor={highlightNodeColor}
                           standardNodeColor={standardNodeColor} standardEdgeColor={standardEdgeColor}
                           highlightEdgeColor={highlightEdgeColor}
                           edgeSettingsSocialSpatial={edgeSettingsSocialSpatial}
                           edgeSettingsSocialSocial={edgeSettingsSocialSocial}
                           edgeSettingsAdvanced={edgeSettingsAdvanced}
                           setEdgeSettingsSocialSpatial={setEdgeSettingsSocialSpatial}
                           setEdgeSettingsSocialSocial={setEdgeSettingsSocialSocial}
                           setEdgeSettingsAdvanced={setEdgeSettingsAdvanced}
                           nodeSettingsSocial={nodeSettingsSocial} nodeSettingsSpatial={nodeSettingsSpatial}
                           nodeSettingsAdvanced={nodeSettingsAdvanced}
                           setNodeSettingsSocial={setNodeSettingsSocial} setNodeSettingsSpatial={setNodeSettingsSpatial}
                           setNodeSettingsAdvanced={setNodeSettingsAdvanced}
                           setStandardNodeColor={setStandardNodeColor}
                           setHighlightNodeColor={setHighlightNodeColor}
                           setStandardEdgeColor={setStandardEdgeColor}
                           setHighlightEdgeColor={setHighlightEdgeColor}
                           nodeRadius={nodeRadius} edgeWidth={edgeWidth} nodeFontColor={nodeFontColor}
                           edgeFontColor={edgeFontColor}
                           setPrimaryColor={props.setPrimaryColor} setSecondaryColor={props.setSecondaryColor}
                           setNodeRadius={setNodeRadius} setEdgeWidth={setEdgeWidth}
                           setNodeLabelColor={setNodeFontColor} setEdgeLabelColor={setEdgeFontColor}
                           setShowNodeLabels={setShowNodeLabels} setShowEdgeLabels={setShowEdgeLabels}
                           showNodeLabels={showNodeLabels} showEdgeLabels={showEdgeLabels}
                           darkMode={props.darkMode} setDarkMode={props.setDarkMode}>
                </TopNavBar>
                <div className="flex w-full justify-start h-full ">
                    <SideBar theme={props.theme}
                             ref={sideBarRef}
                             setCurrentCombiner={setCurrentCombiner}
                             download={download} handleExport={handleExportProject}
                             unsavedChanges={unsavedChanges} setUnsavedChanges={setUnsavedChanges}
                             setIsLoading={setIsLoading}
                             drawGraph={drawGraph} setDrawGraph={setDrawGraph}
                             handleUploadData={handleUploadData} selectedObject={selectedObject}
                             setSelectedObject={setSelectedObject}
                             openProperties={openProperties} setJson={setJsonData}
                             editMode={editMode} historyStack={historyStack} setHistoryStack={setHistoryStack}
                             setFutureStack={setFutureStack} futureStack={futureStack}
                             highlightNodeColor={highlightNodeColor} highlightEdgeColor={highlightEdgeColor}
                             standardNodeColor={standardNodeColor} standardEdgeColor={standardEdgeColor}
                             selectedTab={selectedTab}
                             setEdgeLabels={setEdgeLabels}
                             jsonData={jsonData}/>

                    <div id="networkGraph"
                         className="flex flex-col  relative rounded-lg border-neutral-700 items-center w-4/5"
                         style={{height: "calc(100% - 40px)"}}>
                        {selectedTab !== "combined" &&
                            <ToolBar openToolBar={openToolBar} toolBarToggle={toolBarToggle}
                                     addingNode={addingNode} setAddingNode={setAddingNode}
                                     addingEdge={addingEdge} setAddingEdge={setAddingEdge}
                                     movingNode={movingNode} setMovingNode={setMovingNode}
                                     selectedTab={selectedTab} editMode={editMode}/>


                        }
                        {
                            selectedTab === 'social' &&
                            <ZoomControl zoomRef={zoomRef}/>
                        }

                        <TabNavigator currentTab={selectedTab} setTab={setSelectedTab}/>
                        {
                            isLoading && <CircularProgress color="primary" thickness={2} size={100}
                                                           sx={{position: 'absolute', top: '40%'}}/>
                        }
                        {selectedTab === "combined" && drawCombined.current && !isLoading &&
                            <div className="absolute top-16 left-4" id={"3dgraph"}>
                            </div>
                        }
                        <svg id="networkGraphSvg" className="w-full h-full">
                            {
                                <g id="zoomer">
                                    <defs>
                                        <marker id="arrowhead" viewBox="0 -5 10 10" refX="18" refY="0" markerWidth="3"
                                                markerHeight="4" orient="auto">
                                            <path d="M0,-5L10,0L0,5"/>
                                        </marker>
                                        <marker id="arrowSelected" viewBox="0 -5 10 10" refX="30" refY="0"
                                                markerWidth="3"
                                                markerHeight="4" orient="auto">
                                            <path d="M0,-5L10,0L0,5"/>
                                        </marker>
                                        <marker id="arrowSocialSocial" viewBox="0 -5 10 10" refX="18" refY="0"
                                                markerWidth="3"
                                                markerHeight="4" orient="auto">
                                            <path d="M0,-5L10,0L0,5"/>
                                        </marker>
                                        <marker id="arrowSocialSpatial" viewBox="0 -5 10 10" refX="18" refY="0"
                                                markerWidth="3"
                                                markerHeight="4" orient="auto">
                                            <path d="M0,-5L10,0L0,5"/>
                                        </marker>
                                        {
                                            edgeLabels.map((label, index) => {
                                                return (
                                                    <marker id={`arrowSpecial${label.label}`} key={index}
                                                            viewBox="0 -5 10 10"
                                                            refX="18" refY="0"
                                                            markerWidth="3"
                                                            markerHeight="4" orient="auto">
                                                        <path d="M0,-5L10,0L0,5"/>
                                                    </marker>
                                                )
                                            })
                                        }
                                    </defs>


                                    <g id="forceNodes"/>
                                    <g id="labels"></g>
                                    <g id="staticNodes"/>
                                </g>
                            }

                        </svg>
                    </div>
                </div>
            </div>

        </ThemeProvider>
    );
}

export default NetworkGraph;